import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关于爱丫爱丫影院，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg p-5 md:p-6"
            >
              <h3 className="font-heading text-base font-semibold text-foreground-900">
                {item.question}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}